import React from 'react';
import camelcase from 'camelcase-es5';
import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TCard = {
  id?: string;
  as?: keyof React.JSX.IntrinsicElements;
  padding?: string;
  kind?: string;
  children?: React.ReactNode;
  className?: string;
  utilities?: string[];
  style?: React.CSSProperties;
};

const Card = ({ as = 'article', padding = '', kind = '', ...rest }: TCard) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
    utilities: padding && camelcase(`padding-${padding}`),
  });
  return <Box {...rest} {...conditionalProps} as={as} name="Card" />;
};

export default React.memo(Card);
